/**
 * Starting a Google sign-in. Both Google buttons (SignInModal and the paywall)
 * leave through here.
 *
 * apps/api's Google callback returns the session to the app as a URL fragment
 * (`#session=<jwt>&email=…`), and anyone can build that link, so a visitor who
 * opens one would be signed in to whatever account it carries (login CSRF).
 * Nothing on the return trip tells our own sign-in apart from a crafted link:
 * a same-tab marker does not, because an attacker who can navigate the tab can
 * land their link while the marker is live. So the app shell asks "Continue as
 * <email>?" for EVERY fragment session (AppShell.tsx).
 *
 * FOLLOW-UP (apps/api): bind a nonce through the OAuth state. The web would
 * generate one here, send it on /auth/google/start, apps/api would carry it in
 * its signed state and echo it in the fragment, and the shell could then adopt
 * a matching session without asking. Better still, return a one-time code the
 * web exchanges by POST instead of a session JWT in the URL.
 */
import { BABA_API_BASE_URL } from './baba-api'
import { getClickSignals, getConsentForApi } from './analytics'
import { getStoredReferralCode } from './referral'

/** Leave for Google. Returns to "/" with the session in the fragment. */
export function startGoogleSignIn(): void {
  const params = new URLSearchParams({
    source: 'app',
    return: `${window.location.origin}/`,
  })
  const ref = getStoredReferralCode()
  if (ref) params.set('referral_code', ref)
  // The same ad ids the magic link carries, so a Google sign-up is attributed like an emailed one.
  const signals = getClickSignals()
  for (const key of ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid', 'click_key', 'fbp', 'fbc', 'ttp', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gad_source', 'gad_campaignid', 'click_ts', 'landing_path']) {
    if (signals[key]) params.set(key, signals[key])
  }
  const consent = getConsentForApi()
  if (consent) params.set('consent', JSON.stringify(consent))
  window.location.href = `${BABA_API_BASE_URL}/auth/google/start?${params.toString()}`
}
